import * as ActionTypes from "constants/ActionTypes";
import { AssetUploadSet } from "types/Asset";
import { AssetUploadAction } from "types/Actions";

// We separate the upload progress from the clips reducer because it changes rapidly and we want to avoid too many rerenders
export default function AssetUploadReducer(
  assetUploads: AssetUploadSet,
  action: AssetUploadAction
): AssetUploadSet {
  switch (action.type) {
    case ActionTypes.ASSET_UPLOAD_STARTED:
      return {
        ...assetUploads,
        [action.assetId]: {
          id: action.assetId,
          progress: 0,
        },
      };

    case ActionTypes.ASSET_UPLOAD_PROGRESS:
      return {
        ...assetUploads,
        [action.assetId]: {
          id: action.assetId,
          progress: action.progress,
        },
      };

    default:
      return assetUploads;
  }
}
